module.exports = __webpack_public_path__ + "static/img/D’ici_2030.1db0abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/D’ici_2030.jpg
// module id = 4z+k
// module chunks = 0